import { FRONT_STYLE } from "@/data/founders";
import { LogoReveal } from "@/components/LogoReveal";

const Wordmark = () => (
  <div
    data-testid="wordmark-panel"
    className="relative flex w-full flex-col items-center text-center"
  >
    <div className="wordmark-glow" aria-hidden="true" />
    <span className="relative mb-5 flex items-center gap-2" aria-hidden="true">
      <span className="h-px w-8 bg-gold/40" />
      <span className="h-1 w-1 rotate-45 bg-gold/70" />
      <span className="h-px w-8 bg-gold/40" />
    </span>
    <h1
      data-testid="wordmark-title"
      className="wordmark-text relative font-display text-[56px] font-semibold leading-none tracking-[0.14em] pl-[0.14em]"
    >
      ASCEND
    </h1>
    <p
      data-testid="wordmark-subtitle"
      className="relative mt-3 pl-[0.5em] text-[10px] font-medium tracking-[0.5em] text-white/70"
    >
      FINANCE GROUP
    </p>
    <span className="relative mt-5 flex items-center gap-2" aria-hidden="true">
      <span className="h-px w-8 bg-gold/40" />
      <span className="h-1 w-1 rotate-45 bg-gold/70" />
      <span className="h-px w-8 bg-gold/40" />
    </span>
  </div>
);

const Logo = () => (
  <div
    data-testid="logo-panel"
    className="relative flex w-[78%] max-w-[250px] items-center justify-center"
  >
    <div className="logo-glow" aria-hidden="true" />
    <LogoReveal />
  </div>
);

export const CardFront = ({ active = true }) => {
  return (
    <div
      data-testid="card-front"
      className={`card-face absolute inset-0 select-none ${active ? "" : "pointer-events-none"}`}
    >
      <div className="card-sheen" aria-hidden="true" />
      <div className="pointer-events-none absolute inset-3 rounded-2xl border border-gold/25" />
      <div className="pointer-events-none absolute inset-[15px] rounded-xl border border-white/[0.05]" />

      <div className="relative z-10 flex h-full flex-col items-center justify-between px-8 py-10">
        <div className="flex w-full flex-col items-center gap-2">
          <span className="h-px w-12 bg-gold/50" />
          <span className="h-1 w-1 rotate-45 bg-gold/60" />
        </div>

        {FRONT_STYLE === "wordmark" ? <Wordmark /> : <Logo />}

        <div
          data-testid="tap-hint"
          className="flex items-center gap-3"
          aria-hidden="true"
        >
          <span className="h-px w-6 bg-gold/30" />
          <span className="h-1.5 w-1.5 rounded-full bg-gold animate-hint-breathe" />
          <span className="pl-[0.45em] text-[10px] font-medium tracking-[0.45em] text-gold/80">
            TAP TO REVEAL
          </span>
          <span className="h-px w-6 bg-gold/30" />
        </div>
      </div>
    </div>
  );
};
